import "./Cards.scss";
import HeaderLogo from "../headerlogo/HeaderLogo";
import LoadingSpinner from "../loading-spinner/LoadingSpinner";
import React from "react";

export interface LogoHeaderCardProps {
    loading?: boolean,
    children?: React.ReactNode
}

const LogoHeaderCard = (props: LogoHeaderCardProps) => (
    <div data-testid="logo-header-card" className="card logo-header">
        <div className="card-title is-centered">
            <HeaderLogo height="80px" />
        </div>
        <div className="card-body is-loading">
            {props.loading && <LoadingSpinner />}
            {!props.loading && props.children}
        </div>
    </div>
);

export default LogoHeaderCard;
